
















































































































































import Vue from "vue";
import Fieldset from "@/components/ui/Fieldset.vue";
import Multiselect from "@/components/ui/Multiselect.vue";
import {
  Element,
  Gewzv,
  Hochwasserpartnerschaften,
  Regionalstelle,
  RegionenType,
} from "@/types";
import GdaClient from "@/assets/gda/gda_client_api";
import { Massnahme } from "@/types/Massnahme";
import { erklServiceInstance } from "@/services/ErklService";
import { alertError } from "@/services/ErrorAlert";

export default Vue.extend({
  name: "RaumbezugTab",
  components: {
    Fieldset,
    Multiselect,
  },
  props: {
    /** maßnahme  */
    value: {
      type: Object as () => Massnahme,
      required: true,
    },
    /** edit mode */
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      kommunen: [] as Element[],
      massnahemKommunen: [] as Element[],
      hochwasserpartenschaften: [] as Element[],
      gewaesserzweckverbaende: [] as Element[],
      regionalstellen: [] as Element[],
    };
  },
  mounted() {
    this.isLoading = true;
    Promise.all([
      erklServiceInstance
        .getRegionalstellen()
        .then((data: Regionalstelle[]) => (this.regionalstellen = data)),
      erklServiceInstance
        .getHwpDaten()
        .then((data: Element[]) => (this.hochwasserpartenschaften = data)),
      erklServiceInstance
        .getGewzv()
        .then((data: Gewzv[]) => (this.gewaesserzweckverbaende = data)),

      erklServiceInstance
        .getMassnahmeKommunen()
        .then((data: Element[]) => (this.kommunen = data)),
    ])
      .catch((error: any) => alertError(error))
      .finally(() => (this.isLoading = false));
  },
  methods: {
    openGDA() {
      ((this as any).$gdaClient as GdaClient).activateLayer([
        "G_VERBANDSGEMEINDEN",
      ]);

      // edit mode
      ((this as any).$gdaClient as GdaClient).editCoordinate(
        this.value.xKoordinate ? parseFloat(this.value.xKoordinate) : null,
        this.value.yKoordinate ? parseFloat(this.value.yKoordinate) : null,
      );
    },
  },
});
